import React from 'react';
import Styled from 'styled-components/macro';
import Image from "../components/Image"
import noImage from "../images/no-image.jpg";

const Styles = Styled.div`
  display: flex;
  align-items: center;
  margin-top: var(--s-small);
  img {
    width: 44px;
    height: 44px;
    border-radius: 100%;
    margin-right: var(--s-tiny);
    object-fit: cover;
    object-position: center;
  }
  p { margin: 0;
    font-size: 14px;
    font-family: var(--f-primary)
  }
  & + & {
    margin-top: 6px;
  }
`;

const Speaker = ({name, company, image, description}) => {
  return (
    <Styles>
      <Image
        src={image ? image.url : noImage}
        alt={name}
        width="44px"
        height="44px"
      />
      <div>
        <p>{name}</p>
        <p>{company}</p>
      </div>
    </Styles>
  );
}

export default Speaker;
